import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";
import { BUSINESS } from "@/lib/siteData";
import Logo from "@/components/site/Logo";

export default function Header() {
  const [open, setOpen] = useState(false);

  const navLinks = [
    { href: "/#services", label: "Services" },
    { href: "/#pricing", label: "Pricing" },
    { href: "/#business", label: "For Business" },
    { href: "/blog", label: "Blog", route: true },
    { href: "/#certifications", label: "Certifications" },
    { href: "/#faq", label: "FAQ" },
    { href: "/#contact", label: "Contact" },
  ];

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-border glass-header"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 md:px-12 h-16 md:h-20">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
          <Logo className="h-14 w-14 md:h-16 md:w-16" />
          <img
            src="/logo-wordmark.png"
            alt={`${BUSINESS.name} — ${BUSINESS.tagline}`}
            className="h-7 md:h-9 w-auto select-none"
            draggable="false"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => (
            l.route ? (
              <Link
                key={l.href}
                to={l.href}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors"
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors"
              >
                {l.label}
              </a>
            )
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={BUSINESS.phoneHref}
            data-testid="header-call-btn"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline"
          >
            <Phone className="h-4 w-4" /> {BUSINESS.phone}
          </a>
          <Button
            asChild
            data-testid="header-book-btn"
            className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-md active:scale-[0.98]"
          >
            <a href="#contact">Book Diagnostic</a>
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 rounded-md hover:bg-muted"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-border bg-background">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              l.route ? (
                <Link
                  key={l.href}
                  to={l.href}
                  onClick={() => setOpen(false)}
                  className="text-sm font-medium py-2 border-b border-border/60"
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-sm font-medium py-2 border-b border-border/60"
                >
                  {l.label}
                </a>
              )
            ))}
            <a
              href={BUSINESS.phoneHref}
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary py-2"
            >
              <Phone className="h-4 w-4" /> {BUSINESS.phone}
            </a>
            <Button asChild className="bg-primary text-primary-foreground w-full mt-2">
              <a href="#contact" onClick={() => setOpen(false)}>Book Diagnostic</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
